import { createTheme } from '@material-ui/core/styles';

const datePickertheme = createTheme({
  overrides: {
    MuiInputBase: {
      root: {
        '&.Mui-error': {
          borderColor: '#F44336',
        },
      },
    },
    MuiFilledInput: {
      root: {
        borderRadius: '4px',
        border: '1px solid #F6F7F9',
        backgroundColor: '#F6F7F9',
        '&:hover': {
          borderColor: '#BBBFC9',
          backgroundColor: '#F6F7F9',
        },
        '&.Mui-focused': {
          borderColor: '#BBBFC9',
          backgroundColor: '#F6F7F9',
        },
        '&.Mui-disabled': {
          backgroundColor: '#F6F7F9',
        },
      },
      input: {
        height: '23px',
        fontSize: '14px',
        fontFamily: 'var(--ff-etelka-text)',
        color: '#222736',
        cursor: 'pointer',
      },
    },
    MuiInputLabel: {
      root: {
        height: '16px',
        fontSize: '14px',
        fontFamily: 'var(--ff-etelka-text)',
        color: '#7D8598',
        '&.Mui-focused': {
          color: '#7D8598',
        },
        '&.Mui-error': {
          color: '#7D8598',
        },
      },
      formControl: {
        top: '5px',
      },
    },
    MuiPaper: {
      root: {
        height: '402px',
        width: '368px',
        marginTop: '8px',
        marginLeft: '15px',
        border: '1px solid #E5E5E5',
        boxSizing: 'border-box',
        borderRadius: '4px',
        '&::-webkit-scrollbar-track': {
          borderRadius: '6px',
          backgroundColor: '#FFFFFF',
          WebkitBoxShadow: 'inset 0 0 6px rgba(0, 0, 0, .1)',
        },
        '&::-webkit-scrollbar': {
          width: '8px',
          backgroundColor: '#FFFFFF',
        },
        '&::-webkit-scrollbar-thumb': {
          borderRadius: '6px',
          backgroundColor: '#4F2651',
        },
      },
    },
    MuiPickersBasePicker: {
      pickerView: {
        maxWidth: '100%',
        maxHeight: '100%',
        overflowX: 'unset',
      },
    },
    MuiPickersYearSelection: {
      container: {
        height: '100%',
      },
    },
    MuiPickersMonthSelection: {
      container: {
        transform: 'translateX(29px) translateY(51px)',
      },
    },
    MuiPickersCalendarHeader: {
      switchHeader: {
        height: '24px',
        width: '336px',
        margin: '0 16px',
        marginTop: '24px',
        marginBottom: '24px',
      },
      daysHeader: {
        maxHeight: '24px',
        margin: '0 16px',
      },
      dayLabel: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '48px',
        height: '24px',
        margin: 0,
        fontSize: '12px',
        fontFamily: 'var(--ff-etelka-text)',
      },
      iconButton: {
        padding: 0,
      },
    },
    MuiTypography: {
      body1: {
        fontSize: '14px',
        lineHeight: '24px',
        fontFamily: 'var(--ff-etelka-text)',
        color: '#222736',
      },
      body2: {
        fontSize: '14px',
        fontFamily: 'var(--ff-etelka-text)',
        color: '#222736',
      },
    },
    MuiPickersYear: {
      root: {
        fontFamily: 'var(--ff-etelka-text)',
        borderRadius: '8px',
        '&:focus': {
          color: '#4F2651',
        },
        '&:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0.04)',
        },
      },
      yearSelected: {
        color: '#4F2651',
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
      },
    },
    MuiPickersMonth: {
      root: {
        fontFamily: 'var(--ff-etelka-text)',
        borderRadius: '8px',
        '&:focus': {
          color: '#4F2651',
        },
        '&:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0.04)',
        },
      },
      monthSelected: {
        color: '#4F2651',
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
      },
    },
    MuiPickersDay: {
      daySelected: {
        backgroundColor: '#4F2651',
        '&:hover': {
          backgroundColor: '#4F2651',
        },
      },
      day: {
        width: '48px',
        height: '48px',
        margin: 0,
      },
      current: {
        color: '#4F2651',
      },
    },
    MuiPickersCalendar: {
      week: {
        height: '48px',
        margin: '0 16px',
      },
    },
    MuiFormHelperText: {
      root: {
        '&.Mui-error': {
          fontFamily: 'var(--ff-etelka-text)',
          color: '#EE312A',
          margin: '4px 0 0 16px',
          fontSize: '10px',
        },
      },
    },
  },
});

export default datePickertheme;
